var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ticket",
      class: {
        "ticket--special": _vm.firstTicketConfiguration.specialProduct,
        "ticket--additional--disabled": _vm.isSoldOut,
      },
    },
    [
      _c("ticket-description", {
        attrs: {
          ticketConfiguration: _vm.firstTicketConfiguration,
          "sold-out": _vm.isSoldOut,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ticket_right " }, [
        _c(
          "div",
          [
            _c("ticket-price", {
              attrs: {
                ticketConfiguration: _vm.firstTicketConfiguration,
                "on-site-products": _vm.onSiteProducts,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ticket__amount--mobile" }, [
          _c("div", { staticClass: "ticket__amount" }, [
            !_vm.firstTicketConfiguration.specialProduct
              ? _c(
                  "button",
                  {
                    staticClass: "ticket__amountChange",
                    attrs: {
                      disabled:
                        _vm.ticketConfigurationCollection.quantity === 0,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.decrementQuantity(
                          _vm.ticketConfigurationCollection
                        )
                      },
                    },
                  },
                  [_vm._v("\n            –\n          ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.firstTicketConfiguration.specialProduct
              ? _c("span", { staticClass: "ticket__amountPlaceholder" })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number.lazy",
                  value: _vm.ticketConfigurationCollection.quantity,
                  expression: "ticketConfigurationCollection.quantity",
                  modifiers: { number: true, lazy: true },
                },
              ],
              staticClass: "ticket__amountInput",
              attrs: {
                type: "number",
                min: "0",
                step: "1",
                max: _vm.ticketConfigurationCollection.maxQuantity,
                readonly: _vm.firstTicketConfiguration.specialProduct,
                disabled: _vm.disableIncrease && _vm.disableDecrease,
              },
              domProps: { value: _vm.ticketConfigurationCollection.quantity },
              on: {
                change: function ($event) {
                  _vm.$set(
                    _vm.ticketConfigurationCollection,
                    "quantity",
                    _vm._n($event.target.value)
                  )
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            !_vm.firstTicketConfiguration.specialProduct
              ? _c(
                  "button",
                  {
                    staticClass:
                      "ticket__amountChange ticketConfiguration__amountChange--add",
                    attrs: { disabled: _vm.disableIncrease },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.incrementQuantity(
                          _vm.ticketConfigurationCollection
                        )
                      },
                    },
                  },
                  [_vm._v("\n            +\n          ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ticket__cart" },
            [
              _c(
                "Modal",
                {
                  ref: "slotSelectionModal",
                  attrs: {
                    disabled:
                      _vm.ticketConfigurationCollection.quantity === 0 ||
                      !_vm.reachedMinPositionQuantity ||
                      _vm.loading,
                    triggerClassList: "ticket__cartButton button",
                  },
                  on: {
                    open: function ($event) {
                      return _vm.onSlotSelectionModalOpen(
                        _vm.ticketConfigurationCollection
                      )
                    },
                  },
                },
                [
                  _c("template", { slot: "trigger" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("global.links.addToShoppingCart")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "ticketModal" },
                      [
                        _c("p", { staticClass: "h1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ticketList.ticketConfiguration.selectSlot"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.ticketConfigurationCollection.quantity,
                          function (index) {
                            return [
                              _c(
                                "div",
                                { staticClass: "ticketModal__item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "h3 ticketModal__itemHeadline",
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$tm(
                                              _vm.firstTicketConfiguration
                                                .product,
                                              "descriptionWebShop"
                                            )
                                          ) +
                                          "\n                      "
                                      ),
                                      _vm.ticketConfigurationCollection
                                        .quantity > 1
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(index) +
                                                " von " +
                                                _vm._s(
                                                  _vm
                                                    .ticketConfigurationCollection
                                                    .quantity
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                      - " +
                                          _vm._s(
                                            _vm.$tm(
                                              _vm.firstTicketConfiguration
                                                .event,
                                              "descriptionExternal"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "ticketModal__itemText" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "ticketList.ticketConfiguration.info"
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.ticketConfigurationCollection
                                      .ticketConfigurations,
                                    function (ticketConfiguration, slotKey) {
                                      return [
                                        ticketConfiguration.slot
                                          ? _c(
                                              "label",
                                              {
                                                key: slotKey,
                                                staticClass:
                                                  "ticketModal__itemSlot clr",
                                                attrs: {
                                                  for: index + "-" + slotKey,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectSlot(
                                                      ticketConfiguration
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "ticketModal__itemSlotRadio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: index + "-" + slotKey,
                                                    name: "ticket-" + index,
                                                  },
                                                  domProps: { value: slotKey },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.changeSelection(
                                                        $event,
                                                        index,
                                                        slotKey
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ticketModal__itemSlotCheck",
                                                  },
                                                  [_c("Check")],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ticketModal__itemSlotHeadline",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatTimeString"
                                                          )(
                                                            ticketConfiguration
                                                              .slot.printStart,
                                                            _vm.userLanguage
                                                          )
                                                        ) +
                                                        "\n                      -\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatTimeString"
                                                          )(
                                                            ticketConfiguration
                                                              .slot.printEnd,
                                                            _vm.userLanguage
                                                          )
                                                        ) +
                                                        "\n                      Uhr\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ticketModal__itemSlotText",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateString"
                                                          )(
                                                            ticketConfiguration
                                                              .slot.printStart,
                                                            _vm.userLanguage
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    new Date(
                                                      ticketConfiguration.slot.printStart
                                                    ).getDate() !==
                                                    new Date(
                                                      ticketConfiguration.slot.printEnd
                                                    ).getDate()
                                                      ? [
                                                          _vm._v(
                                                            "\n                        -  " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatDateString"
                                                                )(
                                                                  ticketConfiguration
                                                                    .slot
                                                                    .printEnd,
                                                                  _vm.userLanguage
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("hr"),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          }
                        ),
                        _vm._v(" "),
                        _vm.allSlotsSelected
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "button button-inverted ticket__cartButton--right",
                                attrs: {
                                  disabled:
                                    _vm.ticketConfigurationCollection
                                      .quantity === 0,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addPreselectionToCart(
                                      _vm.ticketConfigurationCollection
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.links.continue"))
                                  ),
                                ]),
                              ]
                            )
                          : _c("p", { staticClass: "h3 ticket__cartError" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ticketList.ticketConfiguration.selectInfo"
                                  )
                                )
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }